import React from "react"
import PropTypes from "prop-types"

const Pin = ({
  style = {},
  fill = "white",
  width = "100%",
  className = "pin",
  viewBox = "0 0 16 16"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <path
    fill={fill}
    d="M8,0C4.691,0,2,2.691,2,6c0,4.159,5.416,9.623,5.646,9.854C7.744,15.951,7.872,16,8,16s0.256-0.049,0.354-0.146  C8.584,15.623,14,10.159,14,6C14,2.691,11.309,0,8,0z M8,9C6.346,9,5,7.654,5,6s1.346-3,3-3s3,1.346,3,3S9.654,9,8,9z"></path>
  </svg>
)

Pin.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Pin
